module.exports = __webpack_public_path__ + "static/media/FangSong-01.e0d0488f.svg";